export const formatCPF = (value: string): string => {
  if (value) {
    return value
      ?.replace(/\D/g, '')
      ?.replace(/(\d{3})(\d)/, '$1.$2')
      ?.replace(/(\d{3})(\d)/, '$1.$2')
      ?.replace(/(\d{3})(\d{1,2})/, '$1-$2')
      ?.replace(/(-\d{2})\d+$/, '$1')
  }
}
